import React from 'react';
import { HashRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AppHeader } from './components/AppHeader';
import { DashboardPage } from './pages/DashboardPage';
import { AdminDashboardPage } from './pages/AdminDashboardPage';
import { NewProposalPage } from './pages/NewProposalPage';
import { ProposalDetailPage } from './pages/ProposalDetailPage';
export function App() {
  return <HashRouter data-id="element-0">
      <div className="h-screen flex flex-col overflow-hidden" data-id="element-1">
        <AppHeader data-id="element-2" />
        <div className="flex-1 min-h-0 overflow-auto" data-id="element-3">
          <Routes data-id="element-4">
            <Route path="/" element={<DashboardPage data-id="element-6" />} data-id="element-5" />
            <Route path="/admin" element={<AdminDashboardPage data-id="element-8" />} data-id="element-7" />
            <Route path="/proposals/new" element={<NewProposalPage data-id="element-10" />} data-id="element-9" />
            <Route path="/proposals/:id" element={<ProposalDetailPage data-id="element-12" />} data-id="element-11" />
            <Route path="/proposals/:id/:tab" element={<ProposalDetailPage data-id="element-14" />} data-id="element-13" />
            <Route path="*" element={<Navigate to="/" replace data-id="element-16" />} data-id="element-15" />
          </Routes>
        </div>
      </div>
    </HashRouter>;
}